import { CommonModule } from '@angular/common';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';
import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import {
  BuildingClient,
  BusinessUnitClient,
  CraftClient,
  SmartPortalApiModule,
  LocationForecastClient,
  UserClient,
} from '@api';
import { DefaultPageComponent } from './default-page/default-page.component';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { ErrorHandlerModule } from './error-handler';
import { throwIfAlreadyLoaded } from './module-import-guard';

const PROVIDERS = [];

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: 'localhost',
  },
  position: 'top-right',
  theme: 'block',
  palette: {
    popup: {
      background: '#000000',
      text: '#ffffff',
      link: '#ffffff',
    },
    button: {
      background: '#f1d600',
      text: '#000000',
      border: 'transparent',
    },
  },
  type: 'info',
  content: {
    header: ',Cookies used on the website!',
    message: 'This website uses cookies to ensure you get the best experience on our website.',
    dismiss: 'Got it!',
    deny: 'Refuse cookies',
    link: 'Learn more',
    // href: '#',
    policy: 'Cookie Policy',
  },
};

@NgModule({
  declarations: [DefaultPageComponent, CookieConsentComponent],
  imports: [
    CommonModule,
    ErrorHandlerModule,
    SmartPortalApiModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
  ],
  exports: [CookieConsentComponent],
  providers: [CraftClient, BusinessUnitClient, BuildingClient, LocationForecastClient, UserClient],
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [...PROVIDERS],
    };
  }
}
